export default {
    path: '/general/referrals-part-c-to-part-b',
    component: () =>
      import('@/views/general-reports/referrals-part-c-to-part-b/Wrapper.vue'),
    children: [
      {
        path: '',
        name: 'referrals-part-c-to-part-b',
        component: () =>
          import('@/views/general-reports/referrals-part-c-to-part-b/Main.vue'),
      },
    ],
  }